module.exports = __webpack_public_path__ + "img/adobe.8c3b26e6.svg";